import { render, staticRenderFns } from "./CardPastTours.vue?vue&type=template&id=6b89ffb4&scoped=true"
import script from "./CardPastTours.vue?vue&type=script&lang=js"
export * from "./CardPastTours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89ffb4",
  null
  
)

export default component.exports